import { DropdownOption } from '@/components/dropdown'
import { OnboardingPageIds } from '@/modules/surveys/configs/onboarding/constants'

export const ACCOUNT_TYPE_URL_PATH_NAME = 'accountType'
export type OnboardingSurveyFields = Record<
  OnboardingFieldNames,
  string | DropdownOption | string[]
>

export const US_COUNTRY_CODE = 'US'
export const US_COUNTRY_CODE_PHONE = '+1'

export enum OnboardingFieldNames {
  AccountType = 'accountType',
  FirstName = 'firstName',
  LastName = 'lastName',
  Country = 'profileCountry',
  MobilePhone = 'mobilePhone',
  Npi = 'npi',
  ConfirmIdentityZipCode = 'confirmIdentityZipCode',
  ConfirmIdentityDateOfBirth = 'confirmIdentityDateOfBirth',
  ConfirmIdentityHomeAddress = 'confirmIdentityHomeAddress',
  ConfirmIdentityHomeCity = 'confirmIdentityHomeCity',
  ConfirmIdentityHomeState = 'confirmIdentityHomeState',
  JobType = 'jobType',
  EstimatedFte = 'estimatedFte',
  TaxStatus = 'taxStatus',
  EmployerType = 'employerType',
  EmployerTypeDetails = 'employerTypeDetails',
  EmployerAcademicAffiliation = 'employerAcademicAffiliation',
  CurrentJobLocation = 'currentJobCityState',
  HoursPerWeek = 'avgHoursPerWeek',
  IsCallPaid = 'isCallPaid',
  CallSchedule = 'callSchedule',
  CallScheduleOther = 'callScheduleOther',
  CallScheduleDetails = 'callScheduleDetails',
  CallRate = 'nightlyRate',
  CallType = 'callType',
  ClinicalPercentage = 'clinicalPct',
  TeachingPercentage = 'teachingPct',
  LeadershipPercentage = 'leadershipPct',
  ResearchPercentage = 'researchPct',
  ScheduledDays = 'scheduledDays',
  ShiftTiming = 'shiftTiming',
  ScheduledHours = 'scheduledHours',
  ProfileWorkStatus = 'workStatus',
  ProfileExpectedCompletionDate = 'expectedCompletionDate',
  ProfileYearsOfTraining = 'yearsOfExperience',
  ProfileSpecialty = 'specialty',
  ProfileSpecialtyId = 'specialtyId',
  Responsibilities = 'responsibilities',
  StudentDegree = 'studentDegreeTrack',
  PhoneCountryCode = 'phoneCountryCode',
  ExpectedCompleteYear = 'expectedCompleteYear',
  ExpectedCompleteMonth = 'expectedCompleteMonth',
  SpecialtyIds = 'specialtyIds',
  StudentSchool = 'schoolUniversity',
  MemberLocation = 'cityState',
  Profession = 'profession',
  CurrentProfessionStatus = 'currentProfessionStatus',
  EmployerName = 'employerName',
  CareerPageUrl = 'careerPageUrl',
  EmployerSpecialtyNames = 'employerSpecialtyIds',
  EmployerTaxStatus = 'employerTaxStatus',
  EmployerHqLocation = 'employerHqLocation',
  NumberOfEmployees = 'numberOfEmployees',
  AvgOpenJobs = 'avgOpenJobs',
  ApplicantTrackingService = 'applicantTrackingService',
  EmployerDescription = 'employerDescription',
  WorkEmail = 'workEmail',
  EmployerUrl = 'employerUrl',
  EmployerRole = 'employerRole',
  EmployerTitle = 'employerTitle',
  EmployerLinkedInUrl = 'employerLinkedInUrl',
  EmployerConfirmRepresent = 'employerConfirmRepresent',
  FacebookPageUrl = 'facebookPageUrl',
  InstagramPageUrl = 'instagramPageUrl',
  EmployerTwitterUrl = 'employerTwitterUrl',
  TikTokPageUrl = 'tikTokPageUrl',
  EmployerYouTubeUrl = 'youTubePageUrl',
  WorkWithUs = 'workWithUs',
  CompensationModel = 'compModel',
  CompensationHourlyRate = 'basePayPerHour',
  CompensationHourlyRateDifferential = 'hourlyRateDifferential',
  CompensationNightlyHourlyRate = 'nightlyHourlyRate',
  CompensationWeekendHourlyRate = 'weekendHourlyRate',
  CompensationAnnualSalary = 'annualSalary',
  CompensationTargetWrvus = 'compTargetWrvu',
  CompensationWrvuRate = 'wrvuRate',
  CollectionsPercentage = 'collectionsPct',
  CompensationOtherDetails = 'compOtherDetails',
  CompensationBonus = 'anyBonuses',
  CompensationProductivityBonus = 'productivityBonus',
  CompensationQualityBonus = 'qualityBonus',
  CompensationOtherBonus = 'otherBonus',
  CompensationOtherIncome = 'anyOtherIncome',
  CompensationOtherOvertimeIncome = 'overtimeIncome',
  CompensationOtherOvertimeRate = 'overtimeRatePerHour',
  CompensationOtherLeadershipStipend = 'annualLeadershipStipend',
  CompensationOtherPartnerIncome = 'annualEstPartnerIncome',
  CompensationOtherRankAdjustment = 'annualEstRankAdjustment',
  CompensationOtherNonClinicalIncome = 'annualNonClinicalIncome',
  CompensationOtherOtherAncillaryIncome = 'annualEstAncillaryIncome',
  CompensationAncillaryIncomeSource = 'ancillaryIncomeSource',
  CompensationSalaryForNewJob = 'newJobWithinLast2Years',
  CompensationMoreIncome = 'benefitsWhenJoined',
  CompensationMoreIncomeSigningBonus = 'signingBonus',
  CompensationMoreIncomeRelocationBonus = 'relocationBonus',
  CompensationMoreIncomeLoanAssistance = 'compLoanAssistance',
  CompensationMoreIncomeResidencyStipend = 'residencyStipend',
  ResidencyOrFellowshipProgram = 'residencyOrFellowshipProgram',
  ResidencyExpectedCompleteMonth = 'residencyExpectedCompleteMonth',
  ResidencyExpectedCompleteYear = 'residencyExpectedCompleteYear',
  WeeksOfVacationsPTO = 'paidTimeOffWeeks',
  RetirementPlans = 'retirementPlans',
  EmployerContributeToRetirement = 'employerContributeToRetirement',
  EmployerContribution401aRetirement = 'employerContribution401a',
  EmployerContribution403bRetirement = 'employerContribution403b',
  EmployerContribution457bRetirement = 'employerContribution457b',
  EmployerContribution401kRetirement = 'employerContribution401k',
  EmployerContributionPensionRetirement = 'employerContributionPension',
  InsuranceHealthBenefits = 'insuranceHealthWellnessBenefits',
  EmployerCoverMalpractice = 'employerCoverMalpractice',
  TailCoverage = 'tailCoverage',
  CmeAllowance = 'cmeAllowance',
  CmeTimeOff = 'cmeTimeWeeks',
  OtherBenefits = 'otherBenefits',
  LoanAssistance = 'loanAssistance',
  LocationDisplayLevel = 'locationDisplayLevel',
  WeeksParentalLeave = 'parentalLeaveWeeks',
  CompensationSatisfaction = 'compSatisfaction',
  OpenToInboundInquiries = 'openToInboundInquiries',
  Feedback = 'feedback',
  OtherNoteworthyComp = 'otherNoteworthyComp',
  PracticeSetting = 'practiceSetting',
  PracticeSettingOther = 'practiceSettingOther',
  IsContractEndDateActive = 'isContractEndDateActive',
  LocumsContractActiveThruMonth = 'locumsContractActiveThruMonth',
  LocumsContractActiveThruYear = 'locumsContractActiveThruYear',
  GuaranteedHoursPerDay = 'locumsGuaranteedHrsPerDay',
  LocumsCallRatePerHour = 'locumsCallRatePerHour',
  IsLocumsCallStipend = 'isLocumsCallStipend',
  LocumsCallStipendWeeklyRate = 'locumsCallStipendWeeklyRate',
  LocumsCallStipendWeekendRate = 'locumsCallStipendWeekendRate',
  LocumsContractingEntity = 'locumsContractingEntity',
  LocumsAgencyBenefits = 'locumsAgencyBenefits',
  LocumsAgencyName = 'locumsAgencyName',
  LocumsAgencyRating = 'locumsAgencyRating',
  LocumsAgencyFeedback = 'locumsAgencyFeedback',
  LocumsEmployerName = 'locumsEmployerName',
}

// default values for form
export function setDefaults(
  acc: OnboardingSurveyFields,
  fieldName: OnboardingFieldNames,
) {
  if (fieldName === OnboardingFieldNames.Country) {
    acc[OnboardingFieldNames.Country] = US_COUNTRY_CODE
  } else if (fieldName === OnboardingFieldNames.CompensationBonus) {
    acc[OnboardingFieldNames.CompensationBonus] = []
  } else if (fieldName === OnboardingFieldNames.CompensationOtherBonus) {
    acc[OnboardingFieldNames.CompensationOtherBonus] = []
  } else {
    acc[fieldName as keyof OnboardingSurveyFields] =
      '' as OnboardingSurveyFields[keyof OnboardingSurveyFields]
  }
  return acc
}

export const genderOptions = ['Male', 'Female', 'Non-Binary']
export const ethnicityOptions = [
  'American Indian',
  'Asian / Pacific Islander',
  'Black / African American',
  'Hispanic',
  'South Asian',
  'White / Caucasian',
  'Multi-Racial',
  'Other',
]

// Fields within each pane
export const paneFieldsMap = {
  [OnboardingPageIds.PersonalInfoProvider]: [
    OnboardingFieldNames.FirstName,
    OnboardingFieldNames.LastName,
    OnboardingFieldNames.Profession,
    OnboardingFieldNames.ProfileWorkStatus,
    OnboardingFieldNames.ProfileSpecialtyId,
    OnboardingFieldNames.ResidencyOrFellowshipProgram,
    OnboardingFieldNames.ResidencyExpectedCompleteMonth,
    OnboardingFieldNames.ResidencyExpectedCompleteYear,
    OnboardingFieldNames.ProfileYearsOfTraining,
    OnboardingFieldNames.Country,
    OnboardingFieldNames.MemberLocation,
  ],
  [OnboardingPageIds.SelectNpi]: [OnboardingFieldNames.Npi],
  // [OnboardingPageIds.ConfirmIdentity]: [
  //   OnboardingFieldNames.ConfirmIdentityHomeAddress,
  //   OnboardingFieldNames.ConfirmIdentityHomeCity,
  //   OnboardingFieldNames.ConfirmIdentityHomeState,
  //   OnboardingFieldNames.ConfirmIdentityZipCode,
  //   OnboardingFieldNames.ConfirmIdentityDateOfBirth,
  // ],
  [OnboardingPageIds.CurrentJob]: [
    OnboardingFieldNames.JobType,
    OnboardingFieldNames.EstimatedFte,
    OnboardingFieldNames.TaxStatus,
    OnboardingFieldNames.EmployerType,
    OnboardingFieldNames.EmployerTypeDetails,
    OnboardingFieldNames.EmployerAcademicAffiliation,
    OnboardingFieldNames.CurrentJobLocation,
    OnboardingFieldNames.IsContractEndDateActive,
    OnboardingFieldNames.LocumsContractActiveThruMonth,
    OnboardingFieldNames.LocumsContractActiveThruYear,
    OnboardingFieldNames.PracticeSetting,
    OnboardingFieldNames.PracticeSettingOther,
  ],
  [OnboardingPageIds.Responsibilities]: [
    OnboardingFieldNames.Responsibilities,
    OnboardingFieldNames.HoursPerWeek,
    OnboardingFieldNames.ScheduledDays,
    OnboardingFieldNames.ShiftTiming,
    OnboardingFieldNames.ScheduledHours,
    OnboardingFieldNames.CallSchedule,
    OnboardingFieldNames.CallScheduleOther,
    OnboardingFieldNames.IsCallPaid,
    OnboardingFieldNames.CallRate,
    OnboardingFieldNames.CallType,
    OnboardingFieldNames.CallScheduleDetails,
    OnboardingFieldNames.ClinicalPercentage,
    OnboardingFieldNames.TeachingPercentage,
    OnboardingFieldNames.LeadershipPercentage,
    OnboardingFieldNames.ResearchPercentage,
    OnboardingFieldNames.GuaranteedHoursPerDay,
  ],
  [OnboardingPageIds.Compensation]: [
    OnboardingFieldNames.CompensationModel,
    OnboardingFieldNames.CompensationHourlyRate,
    OnboardingFieldNames.CompensationHourlyRateDifferential,
    OnboardingFieldNames.CompensationNightlyHourlyRate,
    OnboardingFieldNames.CompensationWeekendHourlyRate,
    OnboardingFieldNames.CompensationOtherDetails,
    OnboardingFieldNames.CompensationAnnualSalary,
    OnboardingFieldNames.CompensationTargetWrvus,
    OnboardingFieldNames.CompensationWrvuRate,
    OnboardingFieldNames.CollectionsPercentage,
    OnboardingFieldNames.CompensationBonus,
    OnboardingFieldNames.CompensationProductivityBonus,
    OnboardingFieldNames.CompensationQualityBonus,
    OnboardingFieldNames.CompensationOtherBonus,
    OnboardingFieldNames.CompensationOtherIncome,
    OnboardingFieldNames.CompensationOtherOvertimeIncome,
    OnboardingFieldNames.CompensationOtherOvertimeRate,
    OnboardingFieldNames.CompensationOtherLeadershipStipend,
    OnboardingFieldNames.CompensationOtherPartnerIncome,
    OnboardingFieldNames.CompensationOtherRankAdjustment,
    OnboardingFieldNames.CompensationOtherNonClinicalIncome,
    OnboardingFieldNames.CompensationOtherOtherAncillaryIncome,
    OnboardingFieldNames.CompensationAncillaryIncomeSource,
    OnboardingFieldNames.CompensationSalaryForNewJob,
    OnboardingFieldNames.CompensationMoreIncome,
    OnboardingFieldNames.CompensationMoreIncomeSigningBonus,
    OnboardingFieldNames.CompensationMoreIncomeRelocationBonus,
    OnboardingFieldNames.CompensationMoreIncomeLoanAssistance,
    OnboardingFieldNames.CompensationMoreIncomeResidencyStipend,
    OnboardingFieldNames.OtherNoteworthyComp,
    OnboardingFieldNames.LocumsCallRatePerHour,
    OnboardingFieldNames.IsLocumsCallStipend,
    OnboardingFieldNames.CompensationWeekendHourlyRate,
    OnboardingFieldNames.LocumsCallStipendWeeklyRate,
    OnboardingFieldNames.LocumsCallStipendWeekendRate,
  ],
  [OnboardingPageIds.Benefits]: [
    OnboardingFieldNames.WeeksOfVacationsPTO,
    OnboardingFieldNames.RetirementPlans,
    OnboardingFieldNames.EmployerContributeToRetirement,
    OnboardingFieldNames.EmployerContribution401aRetirement,
    OnboardingFieldNames.EmployerContribution401kRetirement,
    OnboardingFieldNames.EmployerContribution403bRetirement,
    OnboardingFieldNames.EmployerContributionPensionRetirement,
    OnboardingFieldNames.EmployerContribution457bRetirement,
    OnboardingFieldNames.InsuranceHealthBenefits,
    OnboardingFieldNames.EmployerCoverMalpractice,
    OnboardingFieldNames.TailCoverage,
    OnboardingFieldNames.CmeAllowance,
    OnboardingFieldNames.CmeTimeOff,
    OnboardingFieldNames.OtherBenefits,
    OnboardingFieldNames.LoanAssistance,
    OnboardingFieldNames.WeeksParentalLeave,
    OnboardingFieldNames.CompensationSatisfaction,
    OnboardingFieldNames.OpenToInboundInquiries,
  ],
  [OnboardingPageIds.LocumPrnWrapUp]: [
    OnboardingFieldNames.CompensationSatisfaction,
    OnboardingFieldNames.OpenToInboundInquiries,
    OnboardingFieldNames.LocumsContractingEntity,
    OnboardingFieldNames.LocumsAgencyBenefits,
    OnboardingFieldNames.LocumsAgencyName,
    OnboardingFieldNames.LocumsAgencyRating,
    OnboardingFieldNames.LocumsAgencyFeedback,
    OnboardingFieldNames.LocumsEmployerName,
  ],
  [OnboardingPageIds.ReviewInfo]: [],
  [OnboardingPageIds.PersonalInfoStudent]: [
    OnboardingFieldNames.FirstName,
    OnboardingFieldNames.LastName,
    OnboardingFieldNames.StudentDegree,
    OnboardingFieldNames.StudentSchool,
    OnboardingFieldNames.ExpectedCompleteMonth,
    OnboardingFieldNames.ExpectedCompleteYear,
    OnboardingFieldNames.Country,
    OnboardingFieldNames.MemberLocation,
  ],
  [OnboardingPageIds.UnlockAccount]: [],
  [OnboardingPageIds.PersonalInfoEmployer]: [
    OnboardingFieldNames.EmployerName,
    OnboardingFieldNames.FirstName,
    OnboardingFieldNames.LastName,
    OnboardingFieldNames.WorkEmail,
    OnboardingFieldNames.EmployerRole,
    OnboardingFieldNames.EmployerTitle,
    OnboardingFieldNames.EmployerLinkedInUrl,
    OnboardingFieldNames.MemberLocation,
    OnboardingFieldNames.Country,
    OnboardingFieldNames.EmployerConfirmRepresent,
  ],
  [OnboardingPageIds.EmployerInfo]: [
    OnboardingFieldNames.EmployerUrl,
    OnboardingFieldNames.EmployerType,
    OnboardingFieldNames.EmployerSpecialtyNames,
    OnboardingFieldNames.EmployerTaxStatus,
    OnboardingFieldNames.EmployerHqLocation,
    OnboardingFieldNames.NumberOfEmployees,
    OnboardingFieldNames.EmployerDescription,
    OnboardingFieldNames.AvgOpenJobs,
    OnboardingFieldNames.ApplicantTrackingService,
    OnboardingFieldNames.CareerPageUrl,
    OnboardingFieldNames.FacebookPageUrl,
    OnboardingFieldNames.InstagramPageUrl,
    OnboardingFieldNames.EmployerLinkedInUrl,
    OnboardingFieldNames.EmployerTwitterUrl,
    OnboardingFieldNames.EmployerYouTubeUrl,
    OnboardingFieldNames.TikTokPageUrl,
  ],
}

export function getFieldsForAccountType(
  onboardingPaneIds: OnboardingPageIds[],
) {
  if (!onboardingPaneIds) {
    return []
  }
  return onboardingPaneIds.reduce<OnboardingFieldNames[]>(
    (allFields, paneId) => {
      return [
        ...allFields,
        ...paneFieldsMap[paneId as keyof typeof paneFieldsMap],
      ]
    },
    [OnboardingFieldNames.AccountType],
  )
}
